































































































import Vue from 'vue';
import { Component, Emit } from 'vue-property-decorator';
import DataSource from 'devextreme/data/data_source';
import { DxColumn, DxDataGrid, DxStateStoring } from 'devextreme-vue/data-grid';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { MatterDto } from '@/models/matter/MatterDto';
import { MattersService } from '@/service/MattersService';

interface MatterDetailsDto {
  MatterId: Guid;
  ClientName: string;
  MatterName: string;
  CountryCode: string;
}

@Component({
  components: {
    DxColumn,
    DxDataGrid,
    DxPopup,
    DxStateStoring,
    DxToolbarItem
  }
})
export default class MatterDetails extends Vue {
  private readonly dataGridRef: string = 'dataGridRef';
  private readonly matterService: MattersService = new MattersService();
  private showDialog: boolean = false;
  private colorizedColumns: string[] = [
    'LineItemTotal',
    'PhaseCode',
    'UTBMS'
  ];

  matter: MatterDetailsDto | null = null;

  private get dataGrid() {
    return (this.$refs[this.dataGridRef] as DxDataGrid).instance;
  }

  private get title() {
    if (this.matter == null) {
      return 'Matter Details';
    }

    return `${this.matter.ClientName}, ${this.matter.MatterName}, ${this.matter.CountryCode}`;
  }

  private get dataSource() {
    return new DataSource({
      key: 'InvoiceLineItemId',
      loadMode: 'raw',
      load: () => {
        if (this.matter == null) {
          return [];
        }

        return this.matterService.getLineItems(this.matter.MatterId);
      }
    });
  }

  private get closeButtonOptions() {
    return {
      text: 'Close',
      type: 'normal',
      stylingMode: 'contained',
      onClick: this.close
    };
  }

  show() {
    this.showDialog = true;
  }

  private close() {
    this.showDialog = false;
  }

  private onShowing() {
    if (this.dataGrid != null) {
      this.dataGrid.option('dataSource', this.dataSource);
      this.dataGrid.refresh();
    }
  }

  @Emit('hiding')
  private onHiding() {
    return this.showDialog;
  }

  private onHidden() {
    if (this.dataGrid != null) {
      this.dataGrid.option('dataSource', []);
    }
  }

  private onCellPrepared(e: any) {
    if (e.rowType === 'data' && this.colorizedColumns.includes(e.column.dataField)) {
      e.cellElement.style['background-color'] = e.data.PhaseRgbHex;
    }
  }
}
